module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-fe708dcc.png";